import { useLocationSync } from "@/hooks/useLocationSync";
import { useAuth } from "@/contexts/AuthContext";

export const LocationSyncProvider = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAuth();

  // Sync location every 10 minutes if user is authenticated
  // Only sync if user has moved at least 500 meters
  useLocationSync({
    enabled: !!user,
    syncIntervalMinutes: 10,
    minDistanceMeters: 500,
  });

  return <>{children}</>;
};
